export default __webpack_public_path__ + "static/media/CollegeIcon.502171bb.svg";